import { ChartJsHeight, ChartJsOptions } from "assets/appConfig";
import { DashboardPatterns } from "assets/jss/common-styles";
import { Formaters } from "lib/Formarters";
import { DashboardGraphModel } from "models/ApiModels";
import moment from "moment";
import * as React from "react";
import { Line } from 'react-chartjs-2';

/////////////////////////////////////////////////////////////////////////////////////

interface IRenderGraphProps {
    color: "orange" | "blue" | "green";
    data: DashboardGraphModel[];
    onSelectDay: (day: Date) => void;
}

export const RenderLineGraph: React.FC<IRenderGraphProps> = (props) => {

    const { color, data } = props;

    var ds: number[] = [];
    var labels: string[] = [];
    var currentDate = moment().utc();
    var m = 0;

    data.forEach((v, index) => {
        var vday = moment(v.day);
        var diff = currentDate.diff(vday, "days");

        if (index == 0 || (diff > 1 && m != v.day.getMonth())) {
            labels.push(vday.format("DD/MMM"));
            m = v.day.getMonth();
        }
        else {
            labels.push(diff == 0 ? "Hoje" : diff == 1 ? "Ontem" : vday.format("DD"));
        }
        ds.push(v.total);
    });

    let stepWidth = 1;
    let maxValue = Math.max(...data.map(p => p.total));
    if (maxValue > 0) {
        if (maxValue % 10 !== 0) maxValue += 10 - maxValue % 10;
        stepWidth = Math.ceil(maxValue / 10);
    }
    else
        maxValue = null;

    return (
        <div style={{ position: "relative", height: ChartJsHeight, width: "100%" }}>
            <Line
                data={
                    {
                        labels: labels,
                        datasets: [
                            {

                                label: null,
                                fill: false,
                                ...DashboardPatterns.graphLine[color],
                                data: ds
                            }
                        ]
                    }
                }

                options={
                    {
                        ...ChartJsOptions,

                        plugins: {
                            legend: {
                                display: false
                            },
                            tooltip: {
                                callbacks: {
                                    title: function (item: any) {
                                        return moment(data[item[0].dataIndex].day).format("DD/MMM");
                                    },
                                    label: function (item: any) {
                                        return typeof (item.raw) == "number" ? Formaters.localeNumber(item.raw) : item.formattedValue;
                                    }
                                }
                            }
                        },
                        scales: {
                            x: {
                                display: true,
                                grid: {
                                    display: false
                                }
                            },
                            y: {
                                display: true,
                                grid: {
                                    display: true
                                },

                                beginAtZero: true,
                                suggestedMin: 0,
                                max: maxValue,
                                ticks: {
                                    stepSize: stepWidth
                                }
                            }
                        }
                    }
                }

                getElementsAtEvent={
                    (e) => {
                        if (e.length > 0) {
                            var dt = data[(e[0] as any).index].day;
                            props.onSelectDay(dt);
                        }
                    }
                }
            />
        </div>
    );


};;

/////////////////////////////////////////////////////////////////////////////////////
